import { createSelector } from 'reselect'

const userInterviewsState = (state: any) => state.userInterviews || {}

export const regularInterviews = createSelector(
  [userInterviewsState],
  (userInterviews) => userInterviews.regularInterviews || []
)

export const avaInterviews = createSelector(
  [userInterviewsState],
  (userInterviews) => userInterviews.avaInterviews || []
)

export const isLoading = createSelector(
  [userInterviewsState],
  (userInterviews) => userInterviews.isLoading || false
)

export const error = createSelector(
  [userInterviewsState],
  (userInterviews) => userInterviews.error
)
